module.exports = __webpack_public_path__ + "img/split.6c0b3174.svg";